module.exports = __webpack_public_path__ + "static/media/View-4.a4aa2dcb.webp";